import React, {useState} from "react";
import {Form} from "semantic-ui-react";
import {isAnsel} from "../../utils/common";


const StripeField = ({ component: Component, label, setIsEmpty, setCcInputError }) => {
    const [state, setState] = useState({ focused: true, empty: false, error: false });
    
    const onBlur = () => {
        setState({ ...state, focused: false });
    }

    const onFocus = () => {
        setState({ ...state, focused: true });
    }

    const onChange = ({ empty, error, elementType }) => {
        setState({ ...state, empty, error });
        setIsEmpty(empty);
        if (isAnsel()) {
          setCcInputError((prevState) => ({
            ...prevState,
            [elementType]: {
              ...prevState[elementType],
              error: error
                ? {
                    ...error,
                    customError: customErrorMsg(elementType, error?.code),
                  }
                : error ?? false,
            },
          }));
        } else {
          setCcInputError(error);
        }
    };

    const customErrorMsg = (elementType, errorCode) => {
        if(elementType === "cardExpiry" && (errorCode === "invalid_expiry_year_past" || errorCode === "invalid_expiry_month_past")){
            return "Please enter a valid expiration date";
        } else {
            return null;
        }
    }

    const { error } = state;

    return (
        <Form.Field error={!!error?.message}>
            <label style={{fontSize: "14px"}}><b>{label}</b></label>
            <div className={'stripeBaseInputStyles'}>
                <Component onChange={onChange} onFocus={onFocus} onBlur={onBlur}/>
            </div>
        </Form.Field>
    )
}

export default StripeField;
